import React from 'react';
import { NavLink } from 'react-router-dom';
import {
  LayoutDashboard,
  FolderKanban,
  Shield,
  Users,
  FileText,
  UserCog,
  Menu,
  X
} from 'lucide-react';

interface SidebarProps {
  isOpen: boolean;
  onToggle: () => void;
}

export const Sidebar: React.FC<SidebarProps> = ({ isOpen, onToggle }) => {
  const navItems = [
    { to: '/demo', icon: LayoutDashboard, label: 'Dashboard' },
    { to: '/demo/proyectos', icon: FolderKanban, label: 'Proyectos' },
    { to: '/demo/propiedad-intelectual', icon: Shield, label: 'Propiedad Intelectual' },
    { to: '/demo/stakeholders', icon: Users, label: 'Stakeholders (CRM)' },
    { to: '/demo/contratos', icon: FileText, label: 'Contratos' },
    { to: '/demo/usuarios', icon: UserCog, label: 'Usuarios y Roles' },
  ];

  return (
    <>
      {/* Mobile overlay */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-20 lg:hidden"
          onClick={onToggle}
        />
      )}

      {/* Sidebar */}
      <aside
        className={`fixed top-0 left-0 z-30 h-screen w-64 bg-gray-900 text-white transition-transform duration-300 ease-in-out ${isOpen ? 'translate-x-0' : '-translate-x-full'
          } lg:translate-x-0`}
      >
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-800">
          <div className="flex items-center space-x-2">
            <Shield className="text-blue-400" size={32} />
            <h1 className="text-xl font-bold">OTRI Manager</h1>
          </div>
          <button
            onClick={onToggle}
            className="lg:hidden text-gray-400 hover:text-white"
          >
            <X size={24} />
          </button>
        </div>

        {/* Navigation */}
        <nav className="p-4 space-y-2">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `flex items-center space-x-3 px-4 py-3 rounded-lg transition-colors ${isActive
                  ? 'bg-blue-600 text-white'
                  : 'text-gray-300 hover:bg-gray-800 hover:text-white'
                }`
              }
              onClick={() => {
                if (window.innerWidth < 1024) {
                  onToggle();
                }
              }}
            >
              <item.icon size={20} />
              <span className="font-medium">{item.label}</span>
            </NavLink>
          ))}
        </nav>

        {/* Footer */}
        <div className="absolute bottom-0 left-0 right-0 p-4 border-t border-gray-800">
          <p className="text-xs text-gray-400 text-center">
            OTRI Manager v1.0.0
          </p>
        </div>
      </aside>

      {/* Mobile menu button */}
      <button
        onClick={onToggle}
        className="fixed top-4 left-4 z-40 lg:hidden bg-gray-900 text-white p-2 rounded-lg shadow-lg"
      >
        <Menu size={24} />
      </button>
    </>
  );
};
